import { Component, Input, OnInit, ViewChild } from "@angular/core";

import { faListAlt } from "@fortawesome/free-solid-svg-icons";
import { ModalDirective } from "ngx-bootstrap/modal";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GroupsEnum } from "../../enum/groups.enum";
import { StructuredOperationOrder } from "../../model/domain/StructuredOperationOrder";
import { AuthService } from "../../services/auth.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";

@Component({
  selector: "app-ordem-operacao-estruturada-lista",
  templateUrl: "./ordem-operacao-estruturada-lista.component.html",
  styleUrls: ["./ordem-operacao-estruturada-lista.component.css"],
})
export class OrdemOperacaoEstruturadaListaComponent implements OnInit {
  public groups = GroupsEnum;

  constructor(
    private service: TicketService,
    private snackBarService: SnackbarService,
    private authService: AuthService
  ) {}

  @ViewChild("childModal") public childModal: ModalDirective;

  //FontAwsome
  faListAlt = faListAlt;

  orderId: number = 0;

  @Input() statusDescription: String;
  @Input() totalApprovedAssetsValue: number;
  @Input() totalApprovedAssetsAmount: number;
  @Input() biggestLimitTimestamp: number = null;
  @Input() structuredOperationAssetId: number;
  @Input() structuredOperationAssetSubtypeId: number;

  @Input() mainTicketId: number;
  ticketsList: StructuredOperationOrder[];
  amountSum: number = 0;
  financialSum: number = 0;

  ngOnInit() {
    if (this.mainTicketId) {
      this.loadTickets();
    }
  }

  showChildModal(ticketId: number = null): void {
    this.orderId = ticketId ?? 0;
    this.childModal.show();
  }

  hideChildModal(): void {
    this.childModal.hide();
  }

  closePage(returnType: any) {
    this.hideChildModal();
  }

  canShowGroup(groups: GroupsEnum[]): boolean {
    return this.authService.hasGroup(groups);
  }

  loadTickets() {
    const method = this.service.StructuredOperationOrder.getTicketsList(
      this.mainTicketId
    );

    method
      .pipe(
        catchError((err) => {
          this.snackBarService.open("Ocorreu um erro ao carregar as ordens");
          return throwError("Ocorreu um erro ao carregar as ordens");
        })
      )
      .subscribe((res) => {
        this.ticketsList = res;
        this.ticketsList.forEach((ticket) => {
          if (ticket.statusDescription != "Cancelado pelo Gestor") {
            this.amountSum += ticket.amount;
            this.financialSum += ticket.operationValue;
          }
        });
      });
  }

  reloadTickets() {
    this.ticketsList = [];
    this.amountSum = 0;
    this.financialSum = 0;

    this.loadTickets();
  }
}
